import PageSidebar from './PageSidebar';

export default PageSidebar;



// WEBPACK FOOTER //
// ./src/components/Page/PageSidebar/index.tsx